import React from "react";

const LOGO_SRC = `${process.env.PUBLIC_URL}/AlphaSniperTradingLogo_sans_ecriture_sharpened-removebg-preview.png?v=20260501c`;
const TRADEMARK_SRC = `${process.env.PUBLIC_URL}/AlphaSniperTrading-Black-RBG.png?v=20260501h`;

export default function Maintenance() {
  return (
    <main className="relative flex h-screen flex-col overflow-hidden bg-[#0B1437] px-5 pt-4 pb-8 text-white">
      <div
        className="pointer-events-none absolute inset-0 opacity-40"
        style={{
          background:
            "radial-gradient(ellipse 80% 50% at 50% -20%, rgba(67, 97, 238, 0.35), transparent)",
        }}
      />

      <div className="relative z-10 flex w-full min-h-0 flex-1 flex-col lg:flex-row lg:items-stretch">
        <div className="flex shrink-0 flex-col items-start lg:w-[46%] lg:max-w-[640px]">
          <img
            src={LOGO_SRC}
            alt="AlphaSniper Trading logo"
            className="h-auto w-auto max-h-[52vh] max-w-full object-contain object-left drop-shadow-[0_12px_28px_rgba(0,0,0,0.35)] sm:max-h-[60vh] lg:max-h-[68vh]"
            decoding="async"
          />

          <img
            src={TRADEMARK_SRC}
            alt="AlphaSniper Trading"
            className="-mt-10 h-auto w-full max-h-[38vh] max-w-full object-contain object-left brightness-110 contrast-110 drop-shadow-[0_8px_20px_rgba(0,0,0,0.35)] sm:-mt-14 sm:max-h-[44vh] lg:-mt-16 lg:max-h-[50vh]"
            decoding="async"
          />
        </div>

        <div className="flex min-h-0 min-w-0 flex-1 items-center justify-center px-2 py-6 sm:px-6 lg:px-10">
          <div className="flex w-full max-w-[720px] flex-col items-center justify-center rounded-3xl border border-white/10 bg-white/[0.04] px-8 py-12 text-center shadow-xl backdrop-blur-sm sm:px-12 sm:py-16 lg:min-h-[42vh] lg:w-[88%] lg:max-w-none lg:py-20">
            <div
              className="mx-auto mb-8 flex h-20 w-20 items-center justify-center rounded-full border border-white/15 bg-white/[0.06] sm:mb-10 sm:h-24 sm:w-24"
              aria-hidden="true"
            >
              <svg
                viewBox="0 0 24 24"
                className="h-10 w-10 text-brand-300 sm:h-12 sm:w-12"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.75"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M12 9v4m0 4h.01M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0Z"
                />
              </svg>
            </div>

            <h1 className="text-3xl font-bold tracking-tight sm:text-4xl lg:text-5xl">
              The website is under maintenance
            </h1>
          </div>
        </div>
      </div>

      <p className="absolute inset-x-0 bottom-2 z-10 text-center text-xs text-gray-500 sm:text-sm">
        AlphaSniper Trading © {new Date().getFullYear()} — All Rights Reserved
      </p>
    </main>
  );
}
